// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriptionProgramNdcModel } from './prescriptionProgramNdcModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriptionV2ProgramNdcGetByProgramIdResponse {
    'data': Array<PrescriptionProgramNdcModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriptionV2ProgramNdcGetByProgramIdResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<PrescriptionProgramNdcModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriptionV2ProgramNdcGetByProgramIdResponse.attributeTypeMap;
    }
}
